import React, { useState } from "react";
import axios from "axios";
import { getServiceNameWithNickname } from "../../../../utils/getServiceNameWithNickname";
import userAuthenticationConfig from "../../../../utils/userAuthenticationConfig";
import { check2FA } from "../../../../utils/check2FA";
import getUserInfo from "../../../../utils/getUserInfo";
import DialogModal from "../../../elements/dialogModal/DialogModal";
import TwoFa from "../../../elements/twoFa/TwoFa";
import { useTranslation } from "react-i18next";
import { Alert } from "@material-ui/lab";
import { NavLink } from "react-router-dom";
import PageSpinner from "../../../elements/spinner/PageSpinner";

import {
  StyledCol,
  StyledScrollTable,
  StyledTable,
  StyledTableBody,
  StyledTableHead,
  StyledTableRow
} from "../../../styles/styledTable";
import { parseAxiosError } from "../../../../utils/response";
import { STANDARD_ERRORS_WAY } from "../../../../utils/consts";

const RangeFeeList = ({ fees, refetch, setRefetch, notification, setNotification }) => {
  const { t } = useTranslation("clientsPage");
  const [open, setOpen] = useState(false);
  const [error, setError] = useState({});
  const [id, setId] = useState({});

  const deleteRangeFee = async (event) => {
    event.preventDefault();

    let check2Fa = await check2FA(getUserInfo()["userId"], event.target.twofa.value);

    if (check2Fa.error) {
      setNotification({ ...notification, visible: true, type: "error", message: check2Fa.error });
      return;
    }

    axios.delete(`/api/range-fees/${id}`, userAuthenticationConfig()).then(response => {
      if (response.status === 204) {
        setNotification({ ...notification, visible: true, type: "success", message: t("details.rangeFee.table.success") });
        setRefetch(!refetch);
      }
    }).catch(error => {
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    }).finally(() => setOpen(false));
  };

  if (!fees) {
    return <PageSpinner
      position="center"
      pt="20"
      pb="20"
    />;
  }

  if (fees.length === 0) {
    return <Alert severity="warning">{t("details.rangeFee.table.emptyData")}</Alert>;
  }

  return (
    <>
      <DialogModal
        open={open}
        setOpen={setOpen}
        title={t("details.rangeFee.table.twoFa")}
        content={<TwoFa
          handleSubmit={deleteRangeFee}
          error={error}
        />}
      />
      <StyledScrollTable>
        <StyledTable
          width="1280"
          size="14"
        >
          <StyledTableHead
            scroll="auto"
            col="9"
          >
            <div>
              {t("details.rangeFee.table.service")}
            </div>
            <div>
              {t("details.rangeFee.table.paymentSystem")}
            </div>
            <div>
              {t("details.rangeFee.table.currency")}
            </div>
            <div>
              {t("details.rangeFee.table.type")}
            </div>
            <div>
              {t("details.rangeFee.table.percent")}
            </div>
            <div>
              {t("details.rangeFee.table.const")}
            </div>
            <div>
              {t("details.rangeFee.table.min")}
            </div>
            <div>
              {t("details.rangeFee.table.actions")}
            </div>
            <div />
          </StyledTableHead>
          <StyledTableBody>
            {fees && fees.map((value, key) => (
              <StyledTableRow
                key={key}
                scroll="auto"
                col="9"
              >
                <StyledCol>
                  {getServiceNameWithNickname(value.baseFee.service.name, value.baseFee.service.nickname)}
                </StyledCol>
                <StyledCol>
                  {value.baseFee.paymentSystem.name}
                </StyledCol>
                <StyledCol>
                  {value.baseFee.currency.asset}
                </StyledCol>
                <StyledCol>
                  {value.baseFee.type}
                </StyledCol>
                <StyledCol>
                  {Math.round((value.percent * 100) * 1000) / 1000} %
                </StyledCol>
                <StyledCol>
                  {value.constant}
                </StyledCol>
                <StyledCol>
                  {value.minAmount}
                </StyledCol>
                <StyledCol inline>
                  <NavLink
                    className="table-action table-action_info"
                    to={"/clients/range-fee/" + value.id}
                  >
                    <span className="icon-light-edit" />
                    {t("details.rangeFee.table.edit")}
                  </NavLink>
                </StyledCol>
                <StyledCol inline>
                  <NavLink
                    className="table-action table-action_info"
                    to={"#"}
                    onClick={() => {
                      setOpen(true);
                      setId(value.id);
                    }}
                  >
                    <span className="icon-light-cancel" />
                    {t("details.rangeFee.table.delete")}
                  </NavLink>
                </StyledCol>
              </StyledTableRow>
            ))}
          </StyledTableBody>
        </StyledTable>
      </StyledScrollTable>
    </>
  );
};
export default RangeFeeList;